import type { ReactNode } from 'react';

export type TUINavigationOptions = Record<string, TNavigationOptions>;

export enum NavigationOptionVariant {
  Default = 'default',
  Link = 'link',
  // Effectively makes a link look like a nest, used in top level links.
  SingleWithChevron = 'singleWithChevron',
}

type TNavigationOptionBase = {
  /*
   * the identifier used to navigate around the list
   * must be unique among its siblings
   */
  id: string;
  // displayed text of the option
  text: string;
  /*
   * icon displayed before the text
   * currently only supported by the Nest variant
   */
  icon?: ReactNode;
  disabled?: boolean;
  variant?: NavigationOptionVariant;
};

export type TNavigationOptionLink = TNavigationOptionBase & {
  href: string;
};

export type TNavigationOptionNest = TNavigationOptionBase & {
  children: TNavigationOptions;
  /*
   * Fallback that is applied whenever children are not provided
   */
  href?: string;
};

export type TNavigationOption = TNavigationOptionLink | TNavigationOptionNest;

export type TNavigationOptions = Array<TNavigationOption>;
